import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { showPrice } from "../../utils/showPrice";
import { shortlistedPropertyApi } from "../../api/commonApi";
import { eventEmitter } from "../EventEmitter";
import dummyImg from "../../images/no-image-thumb.jpg";
import AlertModal from "./AlertModal";
import generateSlug from "../common/generateSlug";
import axios from "axios";

const ImageModal = ({
  project,
  handleImagesModalClose,
  contactedId,
  handleShowModal,
  user,
  token,
  handleDispatch,
  properties,
}) => {
  const sliderRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState(
    project?.images[0]?.category || ""
  );
  const [wishlist, setWishlist] = useState([]);
  const [isWishlisted, setIsWishlisted] = useState(false);

  // Function to scroll to selected category image
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);

    // Find the index of the first image in the selected category
    const selectedImageIndex = project?.images.findIndex(
      (image) => image.category === category
    );

    // Scroll to that slide if index exists
    if (sliderRef.current && selectedImageIndex !== -1) {
      sliderRef.current.slickGoTo(selectedImageIndex);
    }
  };

  const uniqueCategories = [
    ...new Set(project?.images.map((image) => image?.category)),
  ].filter(Boolean);

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const feature = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    pauseOnHover: true,
    slidesToShow: project?.images.length === 1 ? 1 : 2, // Show only one slide if there is a single image
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false, // Disable arrows for smaller screens
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const handleShortlist = async (id, status) => {
    const result = await shortlistedPropertyApi({ id, status, user, token });
    if (result?.loginRequired) {
      eventEmitter.emit("loginFirst", true);
      return;
    }
    if (result?.status) {
      handleDispatch();
    } else if (result?.error) {
      alert("Something Went Wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (properties?.wishlist && project) {
      let propertyIds = [];

      if (Array.isArray(project?.property_ids)) {
        propertyIds = project.property_ids.map(String);
      } else if (Array.isArray(project?.[0]?.property_ids)) {
        propertyIds = project[0].property_ids.map(String);
      } else {
        const raw = project?.property_ids || project?.[0]?.property_ids || "";
        propertyIds = String(raw)
          .split(",")
          .map((id) => id.trim())
          .filter((id) => id); // remove empty strings
      }

      const wishlistStr = wishlist.map(String);
      const isWishlistedNow = wishlistStr.some((value) =>
        propertyIds.includes(value)
      );

      console.log("wishlist:", wishlistStr);
      console.log("propertyIds:", propertyIds);
      console.log("isWishlistedNow:", isWishlistedNow);

      setIsWishlisted(isWishlistedNow);
      //  alert(setIsWishlisted);
    }
  }, [wishlist, project]);

  useEffect(() => {
    if (properties?.wishlist) {
      setWishlist(properties.wishlist.map(Number)); // Convert to integers
    }
  }, [properties]);

  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
    setShowAlertModal(true);

    // Auto close after 2 seconds
    setTimeout(() => {
      setShowAlertModal(false);
    }, 1500);
  };

  const sharePropertyLink = async () => {
    
    const data =  project?.slug_detail ? project.slug_detail : project;
    const longUrl = `${window.location.origin}${generateSlug(data)}`;

    try {
      // Step 1: Request backend to save and return short URL
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/saveTinyUrl`,
        {
          original_url: longUrl,
        }
      );

      const shortCode = response.data?.short_code;
      const shortUrl = `${window.location.origin}/${shortCode}`;

      // Step 2: Copy to clipboard
      await navigator.clipboard.writeText(shortUrl);

      // Step 3: Show success alert
      //alert("✅ Short URL copied to clipboard:\n" + shortUrl);
      handleOpenModal();
    } catch (error) {
      console.error("❌ Error generating short URL:", error);
      alert("❌ Failed to generate short URL. Please try again.");
    }
  };

  return (
    <div
      className="modal fade show proplistmodal"
      tabIndex="-1"
      style={{
        display: "block",
        background: "rgba(0, 0, 0, 0.5)",
      }}
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
    >
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className={`image-modal-content i p-3 open`}>
          <div className="modal-body">
            <button
              type="button"
              className="btn-close-image"
              onClick={handleImagesModalClose}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>

            <div className="modal-text">
              <div className="container d-flex justify-content-between prolisttp">
                <div>
                  <p className="image-property-name">{project?.project_name}</p>
                  <p className="image-property-price">
                    {showPrice(project.property_price)}
                  </p>
                </div>
                <div className="shareDiv">
                  <button
                    className="btn sharebtn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation(); // Prevent div click
                      sharePropertyLink(e);
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      className="mob"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.3746 4.66666C11.3746 3.1939 12.5932 2 14.0964 2C15.5996 2 16.8182 3.1939 16.8182 4.66666C16.8182 6.13942 15.5996 7.33334 14.0964 7.33334C13.3374 7.33334 12.6514 7.02877 12.1583 6.53878L8.39047 9.0636C8.42526 9.234 8.44355 9.41 8.44355 9.58976C8.44355 9.94576 8.37202 10.2861 8.24245 10.5971L12.3738 13.2686C12.8428 12.8929 13.4427 12.6666 14.0964 12.6666C15.5996 12.6666 16.8182 13.8606 16.8182 15.3334C16.8182 16.8061 15.5996 18 14.0964 18C12.5932 18 11.3746 16.8061 11.3746 15.3334C11.3746 14.9476 11.4585 14.5804 11.6093 14.2489L7.51129 11.599C7.03325 12.0078 6.40708 12.2564 5.72176 12.2564C4.21858 12.2564 3 11.0625 3 9.58976C3 8.11698 4.21858 6.92308 5.72176 6.92308C6.58614 6.92308 7.3556 7.3178 7.8538 7.93214L11.5054 5.48514C11.4205 5.22687 11.3746 4.95168 11.3746 4.66666Z"
                        fill="white"
                      />
                    </svg>
                    <span className="desk">Share</span>
                  </button>
                  <a
                    onClick={() =>
                      handleShortlist(
                        project?.property_ids,
                        isWishlisted ? 0 : 1
                      )
                    }
                  >
                    <button
                      className={`btn ${isWishlisted ? "savedbtn" : "savebtn"}`}
                    >
                      <span>{isWishlisted ? "Saved" : "Save"}</span>
                    </button>
                  </a>
                  {contactedId.some((item) =>
                    (Array.isArray(project?.property_ids)
                      ? project?.property_ids
                      : [project?.property_ids]
                    ).includes(item)
                  ) ? (
                    <button
                      className="btn contactedseller-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleShowModal(project);
                      }}
                    >
                      Contacted
                    </button>
                  ) : (
                    <button
                      className="btn contseller-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        handleShowModal(project);
                      }}
                    >
                      Contact Seller
                    </button>
                  )}
                </div>
              </div>

              <section className="imageModalSection">
                <div className="container">
                  <div className="d-flex justify-content-between desk">
                    <div style={{ display: "flex", width: "89%" }}>
                      <ul className="image_category">
                        {uniqueCategories.map((category, index) => (
                          <li
                            key={index}
                            className="image_category_list"
                            onClick={() => handleCategoryClick(category)}
                          >
                            <span
                              className={`list_span ${
                                selectedCategory === category ? "active" : ""
                              }`}
                            >
                              {category?.charAt(0).toUpperCase() +
                                category?.slice(1)}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="image-slider-controls">
                      <button
                        className="slider-btn prev-btn"
                        onClick={handlePrevClick}
                      >
                        ❮
                      </button>
                      <button
                        className="slider-btn next-btn"
                        onClick={handleNextClick}
                      >
                        ❯
                      </button>
                    </div>
                  </div>

                  <div className="content content_margin">
                    <Slider ref={sliderRef} {...feature}>
                      {project?.images.map((image, index) => (
                        <div className="modalImageSlides" key={index}>
                          <div className="modalImageSlidebox">
                            <div className="modalImagebox">
                              <div className="imgmodl-mask-container">
                                <img
                                  src={image?.image}
                                  className="target-image"
                                  alt={`Slide ${index}`}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = dummyImg;
                                  }}
                                />
                              </div>
                              {image?.category && (
                                <span className="image_slider_category">
                                  {image.category.charAt(0).toUpperCase() +
                                    image.category.slice(1)}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      {showAlertModal && <AlertModal />}
    </div>
  );
};

export default ImageModal;
